// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Button_icon_button__cfTXS {
  column-gap: 10px;
  display: flex;
  align-items: center;
  flex-wrap: unset;
}

.Button_link_button__PD8G9 {
  background-color: transparent;
  border: none;
  cursor: pointer;
  text-decoration: underline;
  display: inline;
  margin: 0;
  padding: 0;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Button.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,SAAS;EACT,UAAU;AACZ","sourcesContent":[".icon_button {\n  column-gap: 10px;\n  display: flex;\n  align-items: center;\n  flex-wrap: unset;\n}\n\n.link_button {\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  text-decoration: underline;\n  display: inline;\n  margin: 0;\n  padding: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon_button": `Button_icon_button__cfTXS`,
	"link_button": `Button_link_button__PD8G9`
};
export default ___CSS_LOADER_EXPORT___;
